import type { LucideIcon } from 'lucide-react';
import { Link2, Play, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LandingHeroCountdown } from './LandingHeroCountdown';

export type LandingFinalCtaSectionProps = {
  onPrimaryClick: () => void | Promise<void>;
  primaryDisabled?: boolean;
  primaryLabel?: string;
  /** На главной таймер в hero уже в доступном дереве — финальный блок только визуально. */
  duplicateHeroCountdown?: boolean;
};

const FINAL_STEPS: ReadonlyArray<
  | { label: string; variant: 'create' }
  | { label: string; variant: 'icon'; icon: LucideIcon }
> = [
  { label: 'Создайте комнату', variant: 'create' },
  { label: 'Поделитесь ссылкой', variant: 'icon', icon: Link2 },
  { label: 'Начинайте мероприятие', variant: 'icon', icon: Play },
];

export function LandingFinalCtaSection({
  onPrimaryClick,
  primaryDisabled = false,
  primaryLabel = 'Запустить в браузере',
  duplicateHeroCountdown = false,
}: LandingFinalCtaSectionProps) {
  return (
    <section className="cf-final">
      <div className="cf-final-grid">
        <div className="cf-final-copy">
          <h2>Всё готово за пару шагов</h2>
          <ul className="cf-final-steps">
            {FINAL_STEPS.map((step) => (
              <li className="cf-final-step" key={step.label}>
                <span className="cf-final-step-icon" aria-hidden="true">
                  {step.variant === 'create' ? (
                    <span className="cf-final-step-icon-create-mark">
                      <Plus size={12} strokeWidth={3} />
                    </span>
                  ) : (
                    <step.icon
                      size={16}
                      strokeWidth={2.25}
                      fill={step.icon === Play ? 'currentColor' : undefined}
                    />
                  )}
                </span>
                <span>{step.label}</span>
              </li>
            ))}
          </ul>
          <div className="cf-hero-cta-main cf-final-cta-main">
            <Button
              variant="cta"
              size="cta"
              className="cf-landing-cta-hero"
              type="button"
              onClick={() => void onPrimaryClick()}
              disabled={primaryDisabled}
            >
              {primaryLabel}
            </Button>
            <p className="cf-hero-cta-note">Без установки. Работает сразу.</p>
          </div>
        </div>
        <div className="cf-final-visual" {...(duplicateHeroCountdown ? { 'aria-hidden': true } : {})}>
          <div className="cf-timer-card cf-timer-card--live cf-final-timer-card">
            <LandingHeroCountdown decorative={duplicateHeroCountdown} />
          </div>
        </div>
      </div>
    </section>
  );
}
